module.exports = __webpack_public_path__ + "static/media/favicon-mor.0fc844ff.svg";